<template>

  <div class="container">


    <a href="https://www.kancloud.cn/jiuzhoudaijia/shhtsc/2065303" target="_blank">
      <h2>后台使用手册</h2>
    </a>


  </div>

</template>

<script>
  var _this;
  export default {

    data() {
      return {


      };
    },

    methods: {


    }
  };
</script>

<style scoped>
  a{
    display: block;
    margin: 10px 0;
  }
</style>